"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.STATE = void 0;
var STATE = {
  IDLE: 'idle',
  HOVER: 'hover',
  FOCUS: 'focus',
  ERROR: 'error',
  DISABLED: 'disabled'
};
exports.STATE = STATE;